export default __webpack_public_path__ + "047283794234308ba5613f4c8c196ec2.jpg";